import { publicConfig } from '@public-config';

import { ImpersonationService } from 'services/ImpersonationService';

const BeaconService = {
    send: async (endpoint: string, data?: unknown) => {
        // Note that this is only used for ping messages
        // In the future this might change and we'll need to move this logic.
        if (ImpersonationService.isImpersonating()) {
            return;
        }

        const blob = data ? new Blob([JSON.stringify(data)], { type: 'application/json; charset=UTF-8' }) : null;

        navigator.sendBeacon(`${publicConfig.urls.api}${endpoint}`, blob);
    },
};

export default BeaconService;
